__webpack_require__.p = "/result/bihar-poll-25-en/";